import { Component, computed, EventEmitter, HostListener, Input, OnChanges, Output, Signal, signal, SimpleChanges } from '@angular/core';
import { Item } from '../../menu.interfaces';

@Component({
    selector: 'app-menu-item-modal',
    templateUrl: './menu-item-modal.component.html',
    styleUrls: ['./menu-item-modal.component.css'],
    standalone: false
})
export class MenuItemModalComponent implements OnChanges {

  @Input() itemId: number = -1;
  @Input() items: Item[] = [];
  @Input() imagesPath = 'assets/images/pratos/';
  @Input() defaultImagePath = 'default.png';

  @Output() close = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();

  SHOW_BUTTONS = false;

  public selectedItemId = signal(-1);
  
  public selectedItem = computed(() => {
    const id = this.selectedItemId();
    return this.items[id];
  });

  private touchStartX = 0;
  private touchStartY = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['itemId'] && this.itemId >= 0) {
      this.selectedItemId.set(this.itemId);
    }
  }

  onClose(): void {
    this.close.emit();
  }

  onNext(): void {
    this.itemId = (this.itemId + 1) % this.items.length;
    this.selectedItemId.set(this.itemId);
  }

  onPrevious(): void {
    this.itemId = (this.itemId - 1 + this.items.length) % this.items.length;
    this.selectedItemId.set(this.itemId);
  }

  onTouchStart(event: TouchEvent): void {
    const touch = event.touches[0];

    if (!touch) {
      return;
    }

    this.touchStartX = touch.clientX;
    this.touchStartY = touch.clientY;
  }

  onTouchEnd(event: TouchEvent): void {
    const touch = event.changedTouches[0];

    if (!touch) {
      return;
    }

    const deltaX = touch.clientX - this.touchStartX;
    const deltaY = touch.clientY - this.touchStartY;
    const swipeThreshold = 40;

    if (Math.abs(deltaX) < Math.abs(deltaY) || Math.abs(deltaX) < swipeThreshold) {
      return;
    }

    if (deltaX < 0) {
      this.onNext();
      return;
    }

    this.onPrevious();
  }

  onImageError(event: Event): void {
    const image = event.target as HTMLImageElement | null;

    if (!image) {
      return;
    }

    image.onerror = null;
    image.src = this.imagesPath + this.defaultImagePath;
  }

  handleKeydown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.onClose();
    }
  }

  @HostListener('document:keydown.arrowleft', ['$event'])
  onArrowLeft(event: Event): void {
    if (this.itemId < 0) {
      return;
    }

    event.preventDefault();
    this.onPrevious();
  }

  @HostListener('document:keydown.arrowright', ['$event'])
  onArrowRight(event: Event): void {
    if (this.itemId < 0) {
      return;
    }

    event.preventDefault();
    this.onNext();
  }

  trackById(_index: number, item: Item): string {
    return item.id;
  }

  private resetTouchState(): void {
    this.touchStartX = 0;
    this.touchStartY = 0;
  }
}